/** 去掉导航文案末尾 Unicode / ASCII 箭头,图标由 NavChevron 单独渲染 */
export function stripNavArrow(text: string): string {
  return text.replace(/\s*(?:→|←|->|›|‹|»|«)\s*$/u, '').trimEnd()
}
